<template>
  <salesreturn-check-view
    :pagetitle="pagetitle"
    :showprevcheck="true"
  >

  </salesreturn-check-view>
</template>

<script>
import SalesreturnCheckView from '@/views/workbench/workCheckView/salesreturnCheckView/salesreturnCheckView'

export default {
  name: '',
  props: {
    pagetitle: {
      type: String,
      default: '退货超限审批'
    }
  },
  components: { SalesreturnCheckView }
}
</script>

<style scoped>

</style>
